module.exports = __webpack_public_path__ + "static/media/mobileBackground.1daf457b.png";